/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/contains.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Returns a boolean that indicates whether a keyword substring is within another string.
 * Returns `null` if either parameter is null.
 *
 * @example
 * ROW a = "hello"
 * | EVAL has_ll = CONTAINS(a, "ll")
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'contains',
  signatures: [
    {
      params: [
        {
          name: 'string',
          type: 'keyword',
          optional: false,
        },
        {
          name: 'substring',
          type: 'keyword',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'string',
          type: 'keyword',
          optional: false,
        },
        {
          name: 'substring',
          type: 'text',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'string',
          type: 'text',
          optional: false,
        },
        {
          name: 'substring',
          type: 'keyword',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'string',
          type: 'text',
          optional: false,
        },
        {
          name: 'substring',
          type: 'text',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
